import React from 'react';
import {
  HeadingText,
  StackItem,
  StackLayout,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { PageHeaderBackground } from '@leagueplatform/web-common-components';
import { Avatar } from '#components/avatar/index.ts';
import { BackButton } from './back-button';

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  avatar?: {
    image?: string;
    imageAltText: string;
    initials?: string;
    icon?: string;
    iconAltText?: string;
  };
  backButton?: {
    fallbackLocation: string;
  };
};

export function PageHeader({
  title,
  subtitle,
  avatar,
  backButton,
}: PageHeaderProps) {
  return (
    <PageHeaderBackground>
      <StackLayout
        horizontalAlignment="spaceBetween"
        verticalAlignment="center"
        orientation="horizontal"
      >
        <StackLayout orientation="horizontal" spacing="$half">
          {backButton ? (
            <BackButton fallbackLocation={backButton.fallbackLocation} />
          ) : null}
          <StackItem verticalAlignment="center">
            <HeadingText size="xl" level="1">
              {title}
            </HeadingText>
            {subtitle ? <ParagraphText>{subtitle}</ParagraphText> : null}
          </StackItem>
        </StackLayout>
        {avatar ? (
          <StackItem verticalAlignment="center">
            <Avatar
              image={avatar.image}
              imageAltText={avatar.imageAltText}
              initials={avatar.initials}
              icon={avatar.icon}
              iconAltText={avatar.iconAltText}
            />
          </StackItem>
        ) : null}
      </StackLayout>
    </PageHeaderBackground>
  );
}
